import { Grid } from "@mui/material";
import { Container } from "@mui/system";
import { useState } from "react";
import vitaleauImage from "../assets/images/VitalEau-Lieu-5.jpg";
import MetaMaster from "../components/utils/MetaMaster";
import { HeroInner } from "../stories/organisms/HeroInner";

export default function MentionsLegal() {
    const [arianeItem] = useState([
        ["/", "Vital'Eau"],
        ["/mentions-legales", "Mentions légales"],
    ]);

    return (
        <>
            <MetaMaster title="Vital'eau - Piscines Mentions Légales" />
            <HeroInner arianeItem={arianeItem} imagesSwiper={[vitaleauImage]} />
            <section className="section-show-pool-home section-legales" id="accueil-histoire">
                <Container maxWidth="lg">
                    <Grid container>
                        <Grid item lg={12} md={12} sm={12} xs={12}>
                            <div>
                                <h1 className="accueil-histoire-titre h1-inner" data-title="Mentions Légales">
                                    Mentions Légales
                                </h1>
                                <p id="accueil-histoire-baseline"></p>
                            </div>
                        </Grid>
                        <Grid item lg={10} md={10} sm={12} xs={12}>
                            <div className="bloc_info_mentions">
                                <h2>Éditeur</h2>
                                <p>
                                    <strong>Vital'Eau</strong>
                                    <br />
                                    S.A.S. au capital de 8000 euros
                                    <br />
                                    Dont le siège est 31, rue des Petits Ruisseaux – 91370 VERRIERES-LE-BUISSON
                                    <br />
                                    Numéro d’identification : 504 889 965 R.C.S Evry
                                    <br />
                                    Contact : verrieres@vitaleau.fr
                                    <br />
                                </p>

                                <h2>Design et création du site</h2>
                                <p>
                                    Agence RouleMarcel :{" "}
                                    <a href="http://www.roulemarcel.fr" target="new" style={{ color: "#BEBFBF" }}>
                                        www.roulemarcel.fr
                                    </a>
                                    <br/>
                                    Mentions photos
                                </p>

                                <h2>Hébergement</h2>
                                <p>
                                    Le site est hébergé par la société Titan Datacenters France Adresse : 1210 Chem. de la Plaine, 06250 Mougins
                                    Téléphone : +33 9 88 99 88 88 Crédits : Agence RouleMarcel
                                </p>

                                <h2>Conditions d’Utilisation du Site</h2>
                                <p>L’utilisation du Site vaut acceptation des conditions d’utilisation ci-après décrites.</p>

                                <h2>Droits de Propriété Intellectuelle attachés au Site</h2>
                                <p>
                                    Le Site du gymnase aquatique Vital’Eau est une œuvre de l’esprit protégée par le Droit de la Propriété
                                    Intellectuelle. Le site et chacun des éléments qui le composent (tels que notamment marques, logos, photographies,
                                    images, illustrations, textes, slogans, vidéo) sont la propriété exclusive du gymnase aquatique Vital’Eau, seul
                                    habilité à utiliser les droits de la propriété intellectuelle et droits de la personnalité y afférent, celui-ci ne
                                    concédant aucune licence, ni aucun autre droit que celui de consulter le site.
                                </p>
                                <p>
                                    Toute reproduction et/ou représentation intégrale ou partielle, utilisation, adaptation ou modification, du site
                                    ou l’un des quelconques éléments qui le composent sur quelque support que ce soit, et sous quelque forme que ce
                                    soit, à d’autres fins et notamment commerciales est expressément interdit.
                                </p>
                                <p>
                                    Toute reproduction et/ou représentation du Site devra faire l’objet d’une demande d’autorisation préalable auprès
                                    du gymnase aquatique Vital’Eau et adressée à l’adresse suivante : Vital’Eau – 31, rue des Petits Ruisseaux 91370
                                    Verrières-le-Buisson. Toute utilisation non autorisée constitue une contrefaçon sanctionnée pénalement.
                                </p>
                                <p>
                                    La création de liens hypertextes vers le Site ne peut être réalisée qu’avec l’autorisation écrite et préalable du
                                    gymnase aquatique Vital’Eau. Le gymnase aquatique Vital’Eau décline toute responsabilité concernant le contenu, la
                                    publicité, les produits ou services disponibles sur ou à partir des sites liés au Site.
                                </p>
                                <p>
                                    Les marques citées dans le Site sont des marques déposées et donc protégées et sont la propriété exclusive du
                                    gymnase aquatique Vital’Eau.
                                </p>

                                <h2>Informatique et libertés</h2>
                                <p>
                                    Le Site www.vitaleau.fr est déclaré sous le numéro auprès de la Commission Nationale Informatique et Libertés
                                    (CNIL) en application de la loi n°78-17 du 6 janvier 1978 relative à l’informatique, aux fichiers et aux libertés.
                                    Chaque internaute ayant déposé des informations nominatives le concernant sur le Site dispose des droits
                                    d’opposition (article 38 de la loi), d’accès (articles 39, 41 et 42 de la loi) et de rectification (article 40 de
                                    la loi) de ces données. Ainsi, il peut exiger que soient rectifiées, complétées, clarifiées, mises à jour ou
                                    effacées les informations le concernant qui sont inexactes, incomplètes, équivoques, périmées, ou dont la collecte
                                    ou l’utilisation, la communication ou la conservation est interdite. Chaque internaute peut exercer ces droits en
                                    écrivant à Vital’Eau – 31, rue des Petits Ruisseaux 91370 Verrières-le-Buisson ou envoyer un email à
                                    info@vital-eau.com.
                                </p>

                                <h2>Utilisation du site</h2>
                                <p>
                                    Vital’Eau s’efforce de mettre à jour le contenu du Site et de délivrer aux Utilisateurs des informations exactes.
                                    Toutefois, Vital’Eau ne peut garantir l’exactitude, la précision ou l’exhaustivité des données figurant sur le
                                    Site. Vital’Eau décline toute responsabilité pour toute inexactitude ou omission portant sur des données
                                    disponibles sur le Site ainsi que pour tous dommages résultant d’une intrusion frauduleuse d’un tiers ayant
                                    entraîné une modification des dites données. Toute erreur ou omission devra être notifiée à l’adresse suivante :
                                    Vital’Eau – 31, rue des Petits Ruisseaux 91370 Verrières-le-Buisson.
                                </p>

                                <h2>Données Personnelles</h2>
                                <p>
                                    Le gymnase aquatique Vital’Eau pourra être amené à collecter des données personnelles concernant l’Utilisateur du
                                    Site (newsletter, contact, inscriptions, achat en ligne), lesquelles peuvent faire l’objet d’un traitement
                                    informatisé.
                                </p>
                                <p>
                                    Conformément à la Loi du 6 janvier 1978 « Informatique et Liberté », l’utilisateur du Site dispose d’un droit
                                    d’accès, de rectification et de radiation des données le concernant. Pour exercer ce droit, l’Utilisateur doit
                                    adresser une lettre à l’adresse suivante : Vital’Eau – 31, rue des Petits Ruisseaux 91370 Verrières-le-Buisson ou
                                    envoyer un e-mail à bonjour@vitaleau.fr
                                </p>
                                <p>
                                    Le gymnase aquatique Vital’Eau s’engage à préserver la confidentialité des données personnelles transmises par
                                    l’utilisateur dans le cadre de l’utilisation du Site.
                                </p>
                                <p>
                                    Sous réserve d’avoir obtenu le consentement exprès de l’utilisateur lors de la collecte de données, Le gymnase
                                    aquatique Vital’Eau pourra adresser à l’utilisateur des prospections directes ou newsletter par courrier
                                    électronique.
                                </p>

                                <h2>Limitation de responsabilité</h2>
                                <p>
                                    Le gymnase aquatique Vital’Eau décline toute responsabilité pour toute survenance de bogues, pour tous dommages
                                    résultant d’une intrusion frauduleuse d’un tiers ayant entraîné une modification des informations mises à la
                                    disposition sur le Site et plus généralement pour tous dommages, direct ou indirect, qu’elles qu’en soient les
                                    causes, origines, natures ou conséquences, provoqués à raison de l’accès de quiconque au Site ou de
                                    l’impossibilité d’y accéder.
                                </p>
                                <p>
                                    En particulier, le gymnase aquatique Vital’Eau décline toute responsabilité pour les dommages qui pourraient être
                                    causés au matériel informatique des utilisateurs suite à leurs accès au présent Site.
                                </p>

                                <h2>Accès au Site</h2>
                                <p>
                                    Le gymnase aquatique Vital’Eau s’efforce de maintenir accessible le Site, sans pour autant être tenue à une
                                    obligation d’y parvenir. Il est précisé qu’à des fins de maintenance, de mise à jour, et pour toute autre raison
                                    notamment d’ordre technique, l’accès au Site pourra être interrompu. Le gymnase aquatique Vital’Eau n’est en aucun
                                    cas responsable de ces interruptions et des conséquences qui peuvent en découler pour l’Utilisateur.
                                </p>

                                <h2>Utilisation de cookies</h2>
                                <p>
                                    Le gymnase aquatique Vital’Eau peut utiliser des cookies sur le Site. Un cookie est un petit fichier informatique
                                    enregistré dans le disque dur de l’ordinateur. Il enregistre des informations relatives à la navigation de
                                    l’ordinateur de l’Utilisateur sur le Site (pages consultées, date, heure et durée de la consultation). Les cookies
                                    ne sont utilisés par Vital’Eau que dans le but de personnaliser le service proposé à l’Utilisateur. Il ne peut, en
                                    aucun cas, endommager les données figurant dans l’ordinateur. L’utilisateur peut s’opposer à l’enregistrement de
                                    cookies en désactivant cette fonction sur son logiciel de navigation (modalités de configurations détaillées sur
                                    le site http://www.cnil.fr). Même lorsque cette fonction est désactivée l’Utilisateur garde la possibilité
                                    d’accéder au Site.
                                </p>

                                <h2>Liens hypertextes mis en place sur le Site</h2>
                                <p>
                                    Les liens hypertextes mis en place sur le Site peuvent conduire l’Utilisateur sur les sites Internet de différents
                                    partenaires. Il est précisé que Vital’Eau n’a pas vérifié tous les sites éventuellement reliés au sien, leur
                                    contenu et les informations qui y sont présentes, et décline par conséquent toute responsabilité sur le contenu,
                                    la publicité, les produits ou les services disponibles sur ces sites et sur l’utilisation qui en est faite par
                                    l’Utilisateur. Le recours à ces sites par l’Utilisateur relève de la seule responsabilité de ce dernier. La
                                    création de liens hypertextes vers le Site ne peut être faite qu’avec l’autorisation écrite et préalable de
                                    Vital’Eau. Toute demande d’autorisation doit être adressée à l’adresse suivante : Vital’Eau – 31, rue des Petits
                                    Ruisseaux 91370 Verrières-le-Buisson. Toute utilisation non autorisée constitue une contrefaçon sanctionnée
                                    pénalement.
                                </p>

                                <h2>Modification de la notice d’utilisation du Site</h2>
                                <p>
                                    Le gymnase aquatique Vital’Eau se réserve le droit de modifier, à tout moment, la présente notice d’utilisation du
                                    Site notamment afin de respecter toute nouvelle réglementation ou législation ou afin d’améliorer la consultation
                                    du Site par l’Utilisateur. Toute modification d’utilisation du Site sera intégrée dans la présente notice.
                                </p>

                                <h2>Loi Applicable – Juridiction</h2>
                                <p>
                                    Les présentes conditions d’utilisation du Site sont soumises au droit français.Tout différend relatif audit Site
                                    sera soumis à la compétence exclusive des tribunaux de Paris.
                                </p>
                            </div>
                        </Grid>
                    </Grid>
                </Container>
            </section>
            <div
                imageUrl={""}
                title={"Mentions Légales"}
                arianeItem={arianeItem}
                intro={
                    <>
                        <h2>Éditeur</h2>
                        <p>
                            <strong>Vital'Eau</strong>
                            <br />
                            S.A.S. au capital de 8000 euros
                            <br />
                            Dont le siège est 31, rue des Petits Ruisseaux – 91370 VERRIERES-LE-BUISSON
                            <br />
                            Numéro d’identification : 504 889 965 R.C.S Evry
                            <br />
                            Contact : bonjour@vitaleau.fr
                            <br />
                            Directeur de la publication : Laure LESSERT
                        </p>

                        <h2>Design et création du site</h2>
                        <p>
                            Agence RouleMarcel :{" "}
                            <a href="http://www.roulemarcel.fr" target="new" style={{ color: "#BEBFBF" }}>
                                www.roulemarcel.fr
                            </a>
                        </p>

                        <h2>Hébergement</h2>
                        <p>
                            Le site est hébergé par la société Titan Datacenters France Adresse : 1210 Chem. de la Plaine, 06250 Mougins Téléphone :
                            +33 9 88 99 88 88 Crédits : Agence RouleMarcel
                        </p>

                        <h2>Conditions d’Utilisation du Site</h2>
                        <p>L’utilisation du Site vaut acceptation des conditions d’utilisation ci-après décrites.</p>

                        <h2>Droits de Propriété Intellectuelle attachés au Site</h2>
                        <p>
                            Le Site du gymnase aquatique Vital’Eau est une œuvre de l’esprit protégée par le Droit de la Propriété Intellectuelle. Le
                            site et chacun des éléments qui le composent (tels que notamment marques, logos, photographies, images, illustrations,
                            textes, slogans, vidéo) sont la propriété exclusive du gymnase aquatique Vital’Eau, seul habilité à utiliser les droits de
                            la propriété intellectuelle et droits de la personnalité y afférent, celui-ci ne concédant aucune licence, ni aucun autre
                            droit que celui de consulter le site.
                        </p>
                        <p>
                            Toute reproduction et/ou représentation intégrale ou partielle, utilisation, adaptation ou modification, du site ou l’un
                            des quelconques éléments qui le composent sur quelque support que ce soit, et sous quelque forme que ce soit, à d’autres
                            fins et notamment commerciales est expressément interdit.
                        </p>
                        <p>
                            Toute reproduction et/ou représentation du Site devra faire l’objet d’une demande d’autorisation préalable auprès du
                            gymnase aquatique Vital’Eau et adressée à l’adresse suivante : Vital’Eau – 31, rue des Petits Ruisseaux 91370
                            Verrières-le-Buisson. Toute utilisation non autorisée constitue une contrefaçon sanctionnée pénalement.
                        </p>
                        <p>
                            La création de liens hypertextes vers le Site ne peut être réalisée qu’avec l’autorisation écrite et préalable du gymnase
                            aquatique Vital’Eau. Le gymnase aquatique Vital’Eau décline toute responsabilité concernant le contenu, la publicité, les
                            produits ou services disponibles sur ou à partir des sites liés au Site.
                        </p>
                        <p>
                            Les marques citées dans le Site sont des marques déposées et donc protégées et sont la propriété exclusive du gymnase
                            aquatique Vital’Eau.
                        </p>

                        <h2>Informatique et libertés</h2>
                        <p>
                            Le Site www.vitaleau.fr est déclaré sous le numéro auprès de la Commission Nationale Informatique et Libertés (CNIL) en
                            application de la loi n°78-17 du 6 janvier 1978 relative à l’informatique, aux fichiers et aux libertés. Chaque internaute
                            ayant déposé des informations nominatives le concernant sur le Site dispose des droits d’opposition (article 38 de la
                            loi), d’accès (articles 39, 41 et 42 de la loi) et de rectification (article 40 de la loi) de ces données. Ainsi, il peut
                            exiger que soient rectifiées, complétées, clarifiées, mises à jour ou effacées les informations le concernant qui sont
                            inexactes, incomplètes, équivoques, périmées, ou dont la collecte ou l’utilisation, la communication ou la conservation
                            est interdite. Chaque internaute peut exercer ces droits en écrivant à Vital’Eau – 31, rue des Petits Ruisseaux 91370
                            Verrières-le-Buisson ou envoyer un email à info@vital-eau.com.
                        </p>

                        <h2>Utilisation du site</h2>
                        <p>
                            Vital’Eau s’efforce de mettre à jour le contenu du Site et de délivrer aux Utilisateurs des informations exactes.
                            Toutefois, Vital’Eau ne peut garantir l’exactitude, la précision ou l’exhaustivité des données figurant sur le Site.
                            Vital’Eau décline toute responsabilité pour toute inexactitude ou omission portant sur des données disponibles sur le Site
                            ainsi que pour tous dommages résultant d’une intrusion frauduleuse d’un tiers ayant entraîné une modification des dites
                            données. Toute erreur ou omission devra être notifiée à l’adresse suivante : Vital’Eau – 31, rue des Petits Ruisseaux
                            91370 Verrières-le-Buisson.
                        </p>

                        <h2>Données Personnelles</h2>
                        <p>
                            Le gymnase aquatique Vital’Eau pourra être amené à collecter des données personnelles concernant l’Utilisateur du Site
                            (newsletter, contact, inscriptions, achat en ligne), lesquelles peuvent faire l’objet d’un traitement informatisé.
                        </p>
                        <p>
                            Conformément à la Loi du 6 janvier 1978 « Informatique et Liberté », l’utilisateur du Site dispose d’un droit d’accès, de
                            rectification et de radiation des données le concernant. Pour exercer ce droit, l’Utilisateur doit adresser une lettre à
                            l’adresse suivante : Vital’Eau – 31, rue des Petits Ruisseaux 91370 Verrières-le-Buisson ou envoyer un e-mail à
                            bonjour@vitaleau.fr
                        </p>
                        <p>
                            Le gymnase aquatique Vital’Eau s’engage à préserver la confidentialité des données personnelles transmises par
                            l’utilisateur dans le cadre de l’utilisation du Site.
                        </p>
                        <p>
                            Sous réserve d’avoir obtenu le consentement exprès de l’utilisateur lors de la collecte de données, Le gymnase aquatique
                            Vital’Eau pourra adresser à l’utilisateur des prospections directes ou newsletter par courrier électronique.
                        </p>

                        <h2>Limitation de responsabilité</h2>
                        <p>
                            Le gymnase aquatique Vital’Eau décline toute responsabilité pour toute survenance de bogues, pour tous dommages résultant
                            d’une intrusion frauduleuse d’un tiers ayant entraîné une modification des informations mises à la disposition sur le Site
                            et plus généralement pour tous dommages, direct ou indirect, qu’elles qu’en soient les causes, origines, natures ou
                            conséquences, provoqués à raison de l’accès de quiconque au Site ou de l’impossibilité d’y accéder.
                        </p>
                        <p>
                            En particulier, le gymnase aquatique Vital’Eau décline toute responsabilité pour les dommages qui pourraient être causés
                            au matériel informatique des utilisateurs suite à leurs accès au présent Site.
                        </p>

                        <h2>Accès au Site</h2>
                        <p>
                            Le gymnase aquatique Vital’Eau s’efforce de maintenir accessible le Site, sans pour autant être tenue à une obligation d’y
                            parvenir. Il est précisé qu’à des fins de maintenance, de mise à jour, et pour toute autre raison notamment d’ordre
                            technique, l’accès au Site pourra être interrompu. Le gymnase aquatique Vital’Eau n’est en aucun cas responsable de ces
                            interruptions et des conséquences qui peuvent en découler pour l’Utilisateur.
                        </p>

                        <h2>Utilisation de cookies</h2>
                        <p>
                            Le gymnase aquatique Vital’Eau peut utiliser des cookies sur le Site. Un cookie est un petit fichier informatique
                            enregistré dans le disque dur de l’ordinateur. Il enregistre des informations relatives à la navigation de l’ordinateur de
                            l’Utilisateur sur le Site (pages consultées, date, heure et durée de la consultation). Les cookies ne sont utilisés par
                            Vital’Eau que dans le but de personnaliser le service proposé à l’Utilisateur. Il ne peut, en aucun cas, endommager les
                            données figurant dans l’ordinateur. L’utilisateur peut s’opposer à l’enregistrement de cookies en désactivant cette
                            fonction sur son logiciel de navigation (modalités de configurations détaillées sur le site http://www.cnil.fr). Même
                            lorsque cette fonction est désactivée l’Utilisateur garde la possibilité d’accéder au Site.
                        </p>

                        <h2>Liens hypertextes mis en place sur le Site</h2>
                        <p>
                            Les liens hypertextes mis en place sur le Site peuvent conduire l’Utilisateur sur les sites Internet de différents
                            partenaires. Il est précisé que Vital’Eau n’a pas vérifié tous les sites éventuellement reliés au sien, leur contenu et
                            les informations qui y sont présentes, et décline par conséquent toute responsabilité sur le contenu, la publicité, les
                            produits ou les services disponibles sur ces sites et sur l’utilisation qui en est faite par l’Utilisateur. Le recours à
                            ces sites par l’Utilisateur relève de la seule responsabilité de ce dernier. La création de liens hypertextes vers le Site
                            ne peut être faite qu’avec l’autorisation écrite et préalable de Vital’Eau. Toute demande d’autorisation doit être
                            adressée à l’adresse suivante : Vital’Eau – 31, rue des Petits Ruisseaux 91370 Verrières-le-Buisson. Toute utilisation non
                            autorisée constitue une contrefaçon sanctionnée pénalement.
                        </p>

                        <h2>Modification de la notice d’utilisation du Site</h2>
                        <p>
                            Le gymnase aquatique Vital’Eau se réserve le droit de modifier, à tout moment, la présente notice d’utilisation du Site
                            notamment afin de respecter toute nouvelle réglementation ou législation ou afin d’améliorer la consultation du Site par
                            l’Utilisateur. Toute modification d’utilisation du Site sera intégrée dans la présente notice.
                        </p>

                        <h2>Loi Applicable – Juridiction</h2>
                        <p>
                            Les présentes conditions d’utilisation du Site sont soumises au droit français.Tout différend relatif audit Site sera
                            soumis à la compétence exclusive des tribunaux de Paris.
                        </p>
                    </>
                }
            />
        </>
    );
}
